export const getSavingsRate = ({
  anchor,
  price,
}: {
  anchor?: number;
  price?: number;
}) => {
  if (!anchor || !price) {
    return 0;
  }

  return Math.round(((anchor - price) * 100) / anchor);
};
